import { createContext } from 'react';

/**
 * Context for a stack-based resizable drawer used by dashboard chart click-throughs.
 * Consumers can push/pop/close drawer "pages" to support nested drill-down navigation
 * (e.g. a CVE list -> the assets a CVE is found in) with a Back button.
 *
 * Value shape: { pushDrawer({ title, content }), popDrawer(), closeDrawer() }
 * Defaults to null so consumers can detect its absence and fall back to legacy behavior.
 */
export const DrawerStackContext = createContext(null);
